var t=function(t){t=t.toLowerCase();for(var r=0,a=0;a<t.length;a++){r=(r<<5)-r+t.charCodeAt(a)}return"#"+((r=Math.abs(r))%16777216).toString(16).padStart(6,"0")};export{t as generateUniqueHexColor};
//# sourceMappingURL=Avatar.helpers.js.map
